import { Utils } from 'common';
import AccountCommunication from './AccountCommunication';

const { Session, Util } = Utils;

export default {
	sendUserToRetention: async accountDetails => {
		const {
			planDetails: { planId, pendingPlanId },
			customerDetails,
			customerId,
			userId,
			internalAccountDetails: { accountType },
		} = accountDetails;

		const urlBase = `${window.location.href}?decision=`;
		const isSas = accountType === 'sas';
		let mstate = '',
			pstate = '';

		// Get the customer details to check if they are in CA or MN
		const [licenseResponse, paymentAccountsResponse] = await Promise.all([
			AccountCommunication.getLicenseInformation(customerId),
			AccountCommunication.getPaymentAccounts(customerId),
		]);

		if (AccountCommunication.isSuccessful(licenseResponse)) {
			mstate = licenseResponse.data.MState || '';
			pstate = licenseResponse.data.PState || '';
		} else {
			return 'Error: Failed to get license information';
		}

		// Process payment accounts
		let paymentStates = [];
		if (AccountCommunication.isSuccessful(paymentAccountsResponse)) {
			paymentStates = paymentAccountsResponse.data.PaymentAccounts.map(
				account => account.BillingAddress?.State
			);
		} else {
			return 'Error: Failed to get payment accounts';
		}

		const states = [mstate, pstate, ...paymentStates];
		const isCaliforniaOrMinnesota =
			states.includes('CA') || states.includes('MN');
		const billingDay = Session.getInternalAccountInfo().BillingDayOfMonth;
		const nextBillingDate = Util.getBillingDate(billingDay, 'numeric');
		const {
			planDetails: { currentPlanServiceFee },
			customerDetails: { creationDate },
		} = Session.getAccountInfo();
		const isInferredTrialist = Util.getAgeOfAccountInDays(creationDate) <= 30;

		// send user to retention
		const url = await AccountCommunication.getCancelUrlFromRetention({
			app_id: 'jwoJybPra6',
			email: customerDetails.email,
			account: {
				internal_id: userId,
			},
			custom: {
				isSas,
				isCaliforniaOrMinnesota,
				planId,
				pendingPlanId: pendingPlanId - 1020000,
				downgrade: {
					basic: `${urlBase}downgrade&offer=basic`,
					paygo: `${urlBase}downgrade&offer=paygo`,
					paygo2: `${urlBase}downgrade&offer=paygo2`,
					retentionbasic: `${urlBase}downgrade&offer=retentionbasic`,
					retentionlite: `${urlBase}downgrade&offer=retentionlite`,
				},
				redirect: {
					chat: `${urlBase}talk`,
				},
				currentPlanServiceFee,
				nextBillingDate,
				isInferredTrialist,
			},
			save_return_url: `${urlBase}stay`,
			cancel_confirmation_url: `${urlBase}cancel`,
		});

		if (url?.data?.url) {
			return url.data.url;
		} else {
			// Error getting Brightback URL.
			return 'Error: Failed to get Brightback URL';
		}
	},
	hasAccountMigratedToAuctanePay: PaymentAccountId => {
		const MINIMUM_SDC_PAYMENTMETHOD_PAYMENTID = 0x10000000000000;
		const { MAX_SAFE_INTEGER } = Number;

		return (
			PaymentAccountId >= MINIMUM_SDC_PAYMENTMETHOD_PAYMENTID &&
			PaymentAccountId <= MAX_SAFE_INTEGER
		);
	},
};
